import { formatToForm } from '@mixins/currency';
import { format as DecimalFormat } from '@mixins/decimal';
import { ITEM_TYPE_SERVICE, ITEM_TYPE_TANK, ITEM_TYPE_TRAILER } from '@models/item';
import Model from '@models/model';
import PurchaseItem from '@models/purchase-item';

export default class OrderItem extends Model {
    static className = 'OrderItem';

    customer_location_item = {};

    customer_location_service_contract = {};

    children = [];

    static allowsEdit = true;

    static allowedFieldEdits = [
        'delivered_qty',
        'pickup_qty',
    ];

    constructor(data) {
        super();
        this.setAttributes(data);
    }

    resource() {
        return 'items';
    }

    relations() {
        return {
            children: OrderItem,
            purchase_item: PurchaseItem,
        };
    }

    get formFieldCasts() {
        return {
            price: formatToForm,
            subtotal: formatToForm,
            cost: formatToForm,
            qty: DecimalFormat,
        };
    }

    get propCasts() {
        return {
            qty: DecimalFormat,
            delivered_qty: DecimalFormat,
            pickup_qty: DecimalFormat,
        };
    }

    isTank() {
        return this.item_type_id === ITEM_TYPE_TANK || this.item_type_id === ITEM_TYPE_TRAILER;
    }

    isServiceItem() {
        return this.item_type_id === ITEM_TYPE_SERVICE;
    }

    isServiceContractItem() {
        return Boolean(this.customer_location_service_contract_id);
    }

    isCustomerInventoryItem() {
        return Boolean(this.customer_location_item_id || this.isServiceContractItem());
    }

    getInventoryItem() {
        // Prefer direct relationship if loaded
        if (this.customer_location_item?.id) {
            return this.customer_location_item;
        }

        // Fallback for legacy orders where customer_location_item_id was not set for service contract items
        if (this.customer_location_service_contract?.customer_location_items) {
            const items = this.customer_location_service_contract.customer_location_items;
            const inventoryItem = items.find((item) => item.id === this.customer_location_item_id)
                || items.find((item) => item.item_id === this.item_id);
            if (inventoryItem) {
                return inventoryItem;
            }
        }

        return {};
    }

    getServiceContract() {
        return this.customer_location_service_contract;
    }

    getItem() {
        if (this.item_id) {
            return this.item;
        }
        if (this.customer_location_item_id) {
            return this.customer_location_item.item;
        }

        return null;
    }

    static getItem(item) {
        const self = new OrderItem(item);
        return self.getItem();
    }
}
